import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { dateToString, encodeBase64, handleGetCookie, checkPermissionByPath, FormatCurrencys } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import { callExportAgent, callExportLifeContractPDF } from "../../../api/export";
import { callCancelContract, callGetContractByKey } from "../../../api/contract/service";
import SmartTable from "../../../components/common/table-component";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import SwalAlert from "../../../components/common/alert";
import items from "../../../data/reportCustomer";

import { CREATE, EDIT, PRINT, DELETE, CLAME } from "../../../utils/commonType"
import { callGetAllProvince } from "../../../api/settings/service";
import { Modal } from "bootstrap";
import statusItems from "../../../data/statusLife"

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const location = useLocation();
	const { pathname } = location;
	let baseUrl = "/admin/callcenter/agentService/save";
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const defaultRequest = { page: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '', provinceId: '', region: '', status: '' };
	const [request, setRequest] = useState(defaultRequest);
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const [requestCancel, setRequestCancel] = useState({ contractNumber: '', insuranceType: 1, remark: '' });

	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);
	const [provinceList, setProvinceList] = useState([]);
	const [regionList, setregionList] = useState([]);

	useEffect(() => {
		loadData();
		loadProvince();
		// PersistentListRoute keeps this component mounted while detail/manage pages are open,
		// so this initial load does not run again when the user presses Back.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const columns = [
		{
			label: 'lifeContractNumber', key: 'id', render: (val, item) => (
				<button className="btn btn-link" onClick={() => navigate(pathname + "/detail/" + encodeBase64(JSON.stringify(item)))}>{val}</button>
			)
		},
		{
			label: 'lifeContractGender', key: 'gender', render: (val) => (
				<span >{t('gender.' + val)}</span>
			)
		},
		{ label: 'lifeContractFullName', style: { minWidth: '156px' }, key: 'fullName' },
		{ label: 'lifeContractAddress', style: { minWidth: '280px' }, key: 'address' },
		{ label: 'lifeContractAgentCode', style: { minWidth: '156px' }, key: 'agentCode' },
		{ label: 'lifeContractPhone', style: { minWidth: '156px' }, key: 'phone' },
		{
			label: 'lifeContractPackage', style: { minWidth: '156px' }, key: 'ageRange', render: (val, item) => (
				val ? (val + t('title.year') + ' - ' + FormatCurrencys(item.payPerMonth)) + "/" + t('currentcy.kip') : '-'
			)
		},
		{
			label: 'lifeContractStatus', key: 'status', render: (val) => (
				<span className={"badge " + (val === '1' ? "bg-success" : "bg-danger")}>{t('statusLife.' + val)}</span>
			)
		},

		{
			label: 'lifeContractDateOfBirth', key: 'dateOfBirth', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'lifeContractCarriredDate', key: 'carriredDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		}, {
			label: 'lifeClameContractStatus', key: 'statusClame', render: (val) => (
				val != null ? <span className={"badge " + (val === 1 ? "bg-warning" : val == 2 ? "bg-success" : 'bg-danger')}>{t('statusClame.' + val)}</span> : '-'
			)
		},
		{
			label: 'lifeContractRemark', style: { minWidth: '156px' }, key: 'remark', render: (val, item) => (
				item.statusClame == 0 ? item.descriptionUser : val ? val : '-'
			)
		},
		{
			label: 'lifeContractCreateAt', key: 'createdAt', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'lifeContractCreateBy', style: { minWidth: '120px' }, key: 'createdBy', render: (val) => (
				val ? val : '-'
			)
		},
		{
			label: 'lifeContractUpdateAt', key: 'updatedAt', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'lifeContractUpdateBy', style: { minWidth: '100px' }, key: 'updatedBy', render: (val) => (
				val ? val : '-'
			)
		}
	];


	const loadData = async (e) => {
		if (e) {
			// ເກັບ page / page size ລ່າສຸດໄວ້ ເພື່ອ restore ຕອນກັບຄືນ
			setRequest((prev) => ({ ...prev, ...e }));
		}

		if (userInfo?.data.user.userTypeId === 3 && !userInfo?.data?.agent?.agentId) {
			SwalAlert.error("", __t("uiText.text292"));
			return;

		}
		let data = { keyword: request.keyword, page: request.page, maxResult: request.maxResult, insuranceType: 1, provinceId: request.provinceId, region: request.region, status: request.status, agentId: userInfo?.data?.agent?.agentId };
		if (e) {
			data = { ...data, ...e }
		}
		const rsp = await dispatch(callGetContractByKey(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)

		}

	}
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince({ showLoading: false }));
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(pathname + "/save/" + encodeBase64(id.contractNumber))
	}
	const handleClame = (item) => {
		const hasClaim = item?.statusClame !== null && item?.statusClame !== undefined;

		if (hasClaim) {
			const trackingData = {
				requestId: item?.claimRequestId || item?.requestClaimId || item?.claimId || null,
				contractNumber: item?.contractNumber,
				view: true,
				tracking: true,
			};

			navigate(
				pathname + "/claimTracking/" + encodeBase64(JSON.stringify(trackingData))
			);
			return;
		}

		navigate(pathname + "/clame/" + encodeBase64(item.contractNumber));
	}

	const cancelContract = (item) => {
		if (item.statusClame || item.statusClame == 1) {
			SwalAlert.error(__t("uiText.text023"), t("errors.clameWaning"),);
			return
		}
		setRequestCancel({
			contractNumber: item.contractNumber,
			insuranceType: 1
		})

	}

	const handleDelete = (e) => {
		e.preventDefault()
		SwalAlert.confirm(t("titleDelete"), t("confirmDelete"), async () => {
			try {
				const rsp = await dispatch(callCancelContract({ ...requestCancel }));
				if (rsp?.payload?.responseCode === "00000") {
					const myModal = document.getElementById("rejectPopupModal");
					const modal = Modal.getInstance(myModal);
					modal.hide();
					SwalAlert.success(t("success.delete"), () => {
						loadData();
					});
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}
	const handleChangeCancel = (e) => {
		const { name, value } = e.target;
		setRequestCancel((prev) => ({
			...prev,
			[name]: value
		})
		);
	};
	const downloadExcel = async () => {
		try {
			let data = { contract: 'LTL_20250322151308' };
			let response = await callExportLifeContractPDF(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `agent_${moment().format("YYYYMMDDHHmmss")}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.contractControl.lifeInsuranceContract")}</h4>

						<div className="group-button-header">
							{
								<PermissionWrapper permission={CREATE}>
									<button type="button" className="btn btn-primary" onClick={() => navigate(pathname + '/save')}>
										<i className="fas fa-plus"></i> {t("button.add")}
									</button>
								</PermissionWrapper>

							}

							{
								<PermissionWrapper permission={PRINT} >
									<button className="btn btn-success" onClick={downloadExcel}>
										<i className="fas fa-file-export"></i> {t("button.exportExcel")}
									</button>
								</PermissionWrapper>
							}

						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('search.region')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="region"
														value={request.region}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															items.region.map((item) => (
																<option key={item.key} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-2 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="status"
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															statusItems.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable //selectable={true} rowKey="id" onConfirmSelected={(item) => { SwalAlert.error(JSON.stringify(item)) }}
											confirmButtonLabel="button.approve" columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData}
											initialPage={request.page} initialMaxResult={request.maxResult}
											actions={(item) => (
												<div style={{ minWidth: 150 }}>
													<PermissionWrapper permission={CLAME}>
														<button
															disabled={(item.statusClame === null || item.statusClame === undefined) && item.status != 1}
															className={
																"btn btn-sm " +
																(item.statusClame !== null && item.statusClame !== undefined
																	? "btn-info"
																	: "btn-success")
															}
															title={
																item.statusClame !== null && item.statusClame !== undefined && item.statusClame !== 0
																	? __t("uiText.text041")
																	: __t("uiText.text293")
															}
															onClick={() => handleClame(item)}
														>
															<i className={
																item.statusClame !== null && item.statusClame !== undefined && item.statusClame !== 0
																	? "fas fa-route"
																	: "fas fa-hospital"
															}></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={EDIT}>
														<button disabled={item.status != 1} className="btn btn-primary btn-sm" onClick={() => handleEdit(item)}>
															<i className="fas fa-pen"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={DELETE}>
														<button disabled={item.status != 1} {
															...(item.statusClame === 1 ? {}
																: { "data-bs-toggle": "modal", "data-bs-target": "#rejectPopupModal" })} className="btn btn-danger btn-sm" onClick={() => cancelContract(item)}>
															<i className="fas fa-trash"></i>
														</button>
													</PermissionWrapper>
												</div>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section >
			<CopyrightFooter />
			<div className="modal fade" id="rejectPopupModal">
				<div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
					<div className="modal-content">
						<button
							type="button"
							className="closed-modal"
							data-bs-dismiss="modal"
						></button>
						{/* End close modal btn */}

						<div className="modal-body">
							{/* <!-- Login modal --> */}
							<div id="login-modal">
								{/* <!-- Login Form --> */}
								<div className="login-form default-form">
									<div className="form-inner">
										<h3>{t("contracts.life.cancel")}</h3>
										<form onSubmit={handleDelete}>
											<div className="default-form">
												<div className="row">
													<div className="col-md-12 form-group">
														<label> {t('contracts.life.remarkCancel')}</label>
														<textarea
															name="remark"
															rows="5"
															cols="40"
															value={requestCancel.remark}
															onChange={handleChangeCancel}
															placeholder={t('contracts.life.clame.description')}
														/>
													</div>
													<div className="col-12 d-flex justify-content-center">
														<div className="m-3">
															<button className="theme-btn btn-style-one w-100" type="submit">
																<i className="fas fa-add"></i>&nbsp;{t("button.save")}
															</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								{/* <!--End Login Form --> */}
							</div>
							{/* <!-- End Login Module --> */}
						</div>
						{/* En modal-body */}
					</div>
					{/* End modal-content */}
				</div>
			</div>
		</div >
	);
};

export default Index;
